module.exports = __webpack_public_path__ + "img/banner12-2@2x.78ac25c2.jpg";